module.exports = __webpack_public_path__ + "img/walk-into-banner.cbf8c628.jpg";